import React from 'react';
import { organsAPI } from 'src/api/modules/organs';
import BaseModal from 'src/common/components/Modal';
import notice from 'src/common/components/Notice';

const DeleteOrganModal = ({ open, onClose, onSuccess, organ }) => {
	const onDeleteData = () => {
		organsAPI
			.delete(organ.id)
			.then(() => {
				onSuccess('Órgano eliminado correctamente', 'success', 3);
			})
			.catch(() => {
				notice('Ha ocurrido un error en su solicitud');
			});
	};

	return (
		<BaseModal
			open={open}
			mainText="Eliminar Órgano Colegiado"
			confirmLabel="Si, eliminar"
			onConfirm={onDeleteData}
			onClose={onClose}
			onCancel={onClose}
		>
			<h5>Seguro que desea eliminar el órgano seleccionado</h5>
		</BaseModal>
	);
};

export default DeleteOrganModal;
